import React from 'react';
import c from 'classnames';
import i18next from 'i18next';

import './style.scss';

const SearchAllContentResultsEmptyState: React.FC = () => {
  const classNames = c('SearchAllContent__Results__EmptyState');

  return (
    <div className={classNames}>
      <div>
        <h2 className="asH3">{i18next.t('components.search.empty_state.title')}</h2>
        <p>{i18next.t('components.search.empty_state.body')}</p>
      </div>
    </div>
  );
};

export default SearchAllContentResultsEmptyState;
